import { required } from "../../../../shared/src/codecs/types/required";
import { string } from "../../../../shared/src/codecs/types/string";
import { integer } from "../../../../shared/src/codecs/types/integer";
import { boolean } from "../../../../shared/src/codecs/types/boolean";
import { union } from "../../../../shared/src/codecs/types/union";
import { nullCodec } from "../../../../shared/src/codecs/types/nullCodec";
import { array as arrayCodec } from "../../../../shared/src/codecs/types/array";
import { TTypeOfCodec } from "../../../../shared/src/codecs/codec";

export const NpsDashboardRowCodec = required({
    nps_answered_at: string(),
    nps_score: integer(),
    nps_feedback_text: string(),
    user_first_name: string(),
    user_last_name: string(),
    user_email: string(),
    user_type: string(),
    case_address_short_string: string(),
    introducer_name: union([string(), nullCodec()]),
    sold_by_sail_homes: boolean(),
});
export const NpsDashboardSummaryCodec = required({
    total_invites_sent: integer(),
    total_responses: integer(),
    promoters: integer(),
    passives: integer(),
    detractors: integer(),
    response_rate: integer(),
    nps_score: integer(),
});
export const NpsDashboardResponseCodec = required({
    rows: arrayCodec(NpsDashboardRowCodec),
    summary: NpsDashboardSummaryCodec,
});
export type TRow = TTypeOfCodec<typeof NpsDashboardRowCodec>;
export type TSummary = TTypeOfCodec<typeof NpsDashboardSummaryCodec>;

const escapeCsv = (v: string | number | null | undefined): string =>
    `"${String(v ?? "").replace(/"/g, '""')}"`;

export const toCsv = (rows: TRow[]): string => {
    const header = ["answered_at", "score", "user_type", "name", "email", "case_address", "introducer", "sold_by_sail_homes", "feedback"];
    const body = rows.map((r) => [
        r.nps_answered_at,
        r.nps_score,
        r.user_type,
        `${r.user_first_name} ${r.user_last_name}`.trim(),
        r.user_email,
        r.case_address_short_string,
        r.introducer_name,
        r.sold_by_sail_homes ? "yes" : "no",
        r.nps_feedback_text,
    ].map(escapeCsv).join(","));
    return [header.join(","), ...body].join("\n");
};
